module.exports = __webpack_public_path__ + "static/media/notif_cam_mic.e147142c.png";